window.addEventListener('resize', function() {
  console.log('resize');
  // todo gallery_1 placement...
  // todo banner_1 image resize...
});
